<template>
  <div class="writeWork">
    <div class="top">
      <span v-if="pageType == 'add'">新增问题配置</span>
      <span v-else>修改问题配置</span>
    </div>
    <div class="main">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form
            :model="form"
            :rules="workSubmitRules"
            ref="workSubmitForm"
            label-width="180px"
            class="demo-ruleForm"
          >
            <work-order-card>
              <h3 slot="card-header">基础配置</h3>
              <div slot="card-body">
                <el-form-item label="工单分类:" prop="parentQaTypeId">
                  <el-select
                    v-model="form.parentQaTypeId"
                    placeholder="工单分类"
                    filterable
                  >
                    <el-option
                      v-for="(item, index) in workCutList"
                      :key="index"
                      :label="item.parentQaTypeName"
                      :value="item.parentTypeId"
                      :disabled="
                        item.parentQaTypeName === '公章资质申请' ||
                        item.parentQaTypeName === '账号开通申请'
                      "
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="工单类型:" prop="qaTypeName">
                  <el-input
                    v-model="form.qaTypeName"
                    maxlength="30"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item label="问题描述:">
                  <el-input
                    type="textarea"
                    v-model="form.qaTypeDesc"
                    resize="none"
                    maxlength="300"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item label="页面提交:">
                  <el-switch
                    v-model="form.enablePageSubmit"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  ></el-switch>
                </el-form-item>
                <el-form-item label="是否启用:">
                  <el-switch
                    v-model="form.status"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                  ></el-switch>
                </el-form-item>
                <el-form-item label="处理流程:">
                  <el-radio-group
                    v-model="form.qaProcessType"
                    @change="(val) => qaProcessTypeChange(val)"
                  >
                    <el-radio label="NORMAL">普通流程</el-radio>
                    <el-radio label="EXAMINE">审批流程</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="问题描述（预填写）:">
                  <el-input
                    v-model="form.preFilledWords"
                    type="textarea"
                    maxlength="300"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item label="提示文案:">
                  <el-input
                    v-model="form.qaTypePrompt"
                    type="textarea"
                    maxlength="300"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </div>
            </work-order-card>
            <work-order-card>
              <h3 slot="card-header">人员配置</h3>
              <div slot="card-body">
                <el-form-item prop="acceptorMode" label="承接人类型">
                  <div>
                    <el-radio
                      v-model="form.acceptorMode"
                      label="SPECIFIC"
                      style="width: 80px"
                      @change="dynamicAcceptorChange"
                      >承接</el-radio
                    >
                    <work-order-user-select-v2
                      v-if="allUserOptions"
                      v-model="form.considerPeoples"
                      :allOptions="allUserOptions"
                      :disabled="
                        form.acceptorMode == 'DYNAMIC' ||
                        form.acceptorMode == ''
                      "
                    ></work-order-user-select-v2>
                  </div>
                  <div>
                    <el-radio
                      v-model="form.acceptorMode"
                      label="DYNAMIC"
                      style="width: 80px"
                      @change="dynamicAcceptorChange"
                      >动态承接</el-radio
                    >
                    <el-select
                      placeholder="请选择承接方式"
                      v-model="dynamicAcceptor"
                      @change="
                        (val) => {
                          dynamicAcceptorSelectChange(val, true);
                        }
                      "
                      :disabled="
                        form.acceptorMode == 'SPECIFIC' ||
                        form.acceptorMode == ''
                      "
                    >
                      <el-option
                        label="区域业务商务负责人"
                        value="REGIONAL_BUSINESS_BUSINESS_MANAGER"
                      ></el-option>
                      <el-option
                        label="机构商务负责人 "
                        value="COMPANY_BUSINESS_MANAGER"
                      ></el-option>
                      <el-option
                        label="客户所属咨询"
                        value="CUSTOMER_CONSULTING"
                      ></el-option>
                      <el-option
                        label="客户所属咨询主管"
                        value="CUSTOMER_CONSULTING_SUPERVISOR"
                      ></el-option>
                    </el-select>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                    >
                      <div slot="content">
                        选择动态承接人后，工单提交时将会新增必填字段:<br />
                        ①业务类型/省-市 ②客户电话/ID ③机构名称<br />
                        用户选择后会自动根据选择条件决定所属承接人，配置时请注意!
                      </div>
                      <i class="el-icon-question" style="margin-left: 10px"></i>
                    </el-tooltip>
                  </div>
                </el-form-item>
                <el-form-item
                  label="可指定承接人:"
                  prop=""
                  v-if="
                    form.acceptorMode === 'SPECIFIC' &&
                    form.considerPeoples.length > 1
                  "
                >
                  <el-switch v-model="form.allowSpecifyAcceptor"></el-switch>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                      开启后，在多个承接人时，用户可手动选择其中一名进行指定
                    </div>
                    <i class="el-icon-question" style="margin-left: 10px"></i>
                  </el-tooltip>
                </el-form-item>
                <!-- <el-form-item label="承接人:" prop="considerPeoples">
                  <work-order-user-select-v2
                    v-if="allUserOptions"
                    v-model="form.considerPeoples"
                    :allOptions="allUserOptions"
                  ></work-order-user-select-v2>
                </el-form-item> -->
                <el-form-item label="提交人:">
                  <work-order-user-select-v2
                    v-if="allUserOptions"
                    v-model="form.submitterPeoples"
                    :allOptions="allUserOptions"
                  ></work-order-user-select-v2>
                </el-form-item>
                <el-form-item label="关注人:">
                  <work-order-user-select-v2
                    v-if="allUserOptions"
                    v-model="form.followPeoples"
                    :allOptions="allUserOptions"
                  ></work-order-user-select-v2>
                  <el-checkbox
                    style="margin-left: 10px"
                    v-model="form.enableEditAttentionUser"
                    >允许编辑</el-checkbox
                  >
                  <el-checkbox
                    style="margin-left: 10px"
                    v-model="form.notifyBuiltIntoFollowPeoples"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                    >
                      <div slot="content">
                        勾选此选项，工单提交后，系统自动提醒内置的关注人
                      </div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                    通知内置关注人
                  </el-checkbox>
                </el-form-item>
                <el-form-item label="重新处理人:">
                  <work-order-user-select-v2
                    v-if="allUserOptions"
                    :multipleLimit="1"
                    v-model="form.reprocessingPersons"
                    :allOptions="allUserOptions"
                  ></work-order-user-select-v2>
                </el-form-item>
              </div>
            </work-order-card>
            <work-order-card>
              <h3 slot="card-header">标签配置</h3>
              <div slot="card-body">
                <el-form-item label="标签组:">
                  <el-select
                    v-model="form.labelGroupId"
                    clearable
                    multiple
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="item in tagsOptions"
                      :key="item.id"
                      :value="Number(item.id)"
                      :label="item.labelGroupName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </work-order-card>
            <work-order-card>
              <h3 slot="card-header">特殊配置</h3>
              <div slot="card-body">
                <el-form-item>
                  <template slot="label">
                    <span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="提交人存在以下状态的工单不能创建新工单"
                        placement="top-start"
                      >
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                      受限工单状态：
                    </span>
                  </template>
                  <el-checkbox-group v-model="form.restrictedStatus">
                    <el-checkbox :label="0">待处理</el-checkbox>
                    <el-checkbox :label="4">处理中</el-checkbox>
                    <el-checkbox :label="1">已处理</el-checkbox>
                    <el-checkbox :label="2">已关闭</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item v-if="form.qaProcessType != 'EXAMINE'">
                  <template slot="label">
                    <span>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="若开启，提交人点击重新处理时，需强制回复一段文字，否则无法重新处理工单"
                        placement="top-start"
                      >
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                      强制回复（重新处理）:
                    </span>
                  </template>
                  <el-switch v-model="form.forceResp"></el-switch>
                </el-form-item>
              </div>
            </work-order-card>
            <el-form-item>
              <el-button
                class="add-details-btn"
                @click="submit"
                :loading="submitLoading"
              >
                提交
              </el-button>
              <el-button class="add-back-btn" @click="cancel">取消</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <work-order-card>
            <h3 slot="card-header">模板配置</h3>
            <div slot="card-body">
              <p>默认模板</p>
              <div>
                <div class="list-item" style="background-color: #cccccc">
                  <i class="el-icon-s-operation"></i>
                  <span>工单分类</span>
                  <el-switch
                    class="required-switch"
                    v-model="switch1"
                    :disabled="true"
                    active-text="必填"
                    inactive-text="选填"
                  ></el-switch>
                </div>
              </div>
              <div>
                <div class="list-item" style="background-color: #cccccc">
                  <i class="el-icon-s-operation"></i>
                  <span>工单类型</span>
                  <el-switch
                    class="required-switch"
                    v-model="switch2"
                    :disabled="true"
                    active-text="必填"
                    inactive-text="选填"
                  ></el-switch>
                </div>
              </div>
              <draggable
                :list="form.templates"
                group="moduleName"
                handle=".handle"
                @change="handleDrag"
                :move="onMoveTemplate"
                id="chooseDrag"
              >
                <div v-for="item in form.templates" :key="item.moduleName">
                  <div class="list-item">
                    <i
                      class="el-icon-s-operation"
                      :class="
                        !initTemplateEnum.includes(item.moduleName)
                          ? 'handle'
                          : 'disabled'
                      "
                    ></i>
                    <span
                      >{{ item.label }}
                      <el-tooltip
                        class="item"
                        effect="dark"
                        placement="top-start"
                      >
                        <div slot="content">{{ item.tips }}</div>
                        <i class="el-icon-question" v-if="item.tips"></i>
                      </el-tooltip>
                    </span>
                    <div class="required-switch">
                      <!-- <el-switch
                        style="margin-right: 10px"
                        v-if="item.moduleName == 'ATTENTION_USER'"
                        v-model="form.defaultNotifySubmitFollowPeoples"
                        active-text="必填"
                        inactive-text="选填"
                      ></el-switch> -->
                      <el-checkbox
                        v-if="item.moduleName == 'ATTENTION_USER'"
                        style="margin-right: 15px"
                        v-model="form.defaultNotifySubmitFollowPeoples"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          placement="top-start"
                        >
                          <div slot="content">
                            勾选此选项，工单提交页面会默认勾选“通知关注人”
                          </div>
                          <i
                            class="el-icon-question"
                            style="margin-right: 0"
                          ></i>
                        </el-tooltip>
                        默认勾选
                        <el-divider direction="vertical"></el-divider>
                      </el-checkbox>
                      <el-switch
                        :disabled="
                          initTemplateEnum.includes(item.moduleName) ||
                          !item.allowChangeRequired
                        "
                        v-model="item.isRequired"
                        active-text="必填"
                        inactive-text="选填"
                      ></el-switch>
                    </div>
                  </div>
                </div>
              </draggable>
              <p>未添加的选项</p>
              <draggable
                :list="templateOther"
                group="moduleName"
                handle=".handle"
                ref="templateOther"
                :move="onMoveTemplate"
                id="unChooseDrag"
              >
                <div
                  class="list-item"
                  v-for="item in templateOther"
                  :key="item.moduleName"
                >
                  <i
                    class="el-icon-s-operation"
                    :class="
                      !initTemplateEnum.includes(item.moduleName)
                        ? 'handle'
                        : 'disabled'
                    "
                  ></i>
                  <span>
                    {{ item.label }}
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top-start"
                    >
                      <div slot="content">{{ item.tips }}</div>
                      <i class="el-icon-question" v-if="item.tips"></i>
                    </el-tooltip>
                  </span>
                  <el-switch
                    class="required-switch"
                    v-model="item.isRequired"
                    active-text="必填"
                    inactive-text="选填"
                    :disabled="!item.allowChangeRequired"
                  ></el-switch>
                </div>
              </draggable>
            </div>
          </work-order-card>
          <work-order-card v-if="form.qaProcessType === 'EXAMINE'">
            <h3 slot="card-header">流程配置</h3>
            <div slot="card-body">
              <!-- 表头 -->
              <el-row style="margin-bottom: 10px; text-align: center">
                <el-col :span="3">
                  <div class="product-bind-head">顺序</div>
                </el-col>
                <el-col :span="7">
                  <div class="product-bind-head">节点名称</div>
                </el-col>
                <el-col :span="7">
                  <div class="product-bind-head">审批人类型</div>
                </el-col>
                <el-col :span="6">
                  <div class="product-bind-head">审批人</div>
                </el-col>
              </el-row>
              <!-- 表单 -->
              <el-form
                size="mini"
                ref="midConsiderForm"
                :model="form.midConsiderPeoples"
                :inline="true"
              >
                <div
                  class="midConsiderDiv"
                  v-for="(item, index) in form.midConsiderPeoples"
                  :key="index"
                >
                  <el-row style="text-align: center">
                    <el-col :span="3">
                      {{ index + 1 }}
                    </el-col>
                    <el-col :span="7">
                      <el-form-item
                        :prop="`${index}.name`"
                        :rules="{
                          required: true,
                          message: '请输入节点名称',
                          trigger: 'blur',
                        }"
                      >
                        <el-input
                          v-model="item.name"
                          size="small"
                          placeholder="节点名称"
                          clearable
                          maxlength="30"
                          style="width: 90%"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="7">
                      <el-form-item
                        :prop="`${index}.type`"
                        :rules="{
                          required: true,
                          message: '请选择审批人类型',
                          trigger: 'change',
                        }"
                      >
                        <el-select
                          v-model="item.type"
                          style="width: 90%"
                          @change="
                            (val) => {
                              typeChange(val, index);
                            }
                          "
                        >
                          <el-option
                            value="SPECIFIC"
                            label="固定审批人"
                          ></el-option>
                          <el-option
                            value="AUTHOR_APPOINT"
                            label="提交人指定审批人"
                          ></el-option>
                          <el-option
                            value="DIRECT_MANAGER"
                            label="提交人直接上级"
                          ></el-option>
                          <el-option
                            value="REGIONAL_MANAGER"
                            label="提交人间接上级"
                          ></el-option>
                          <el-option
                            value="TAIL_DEPT_MANAGER"
                            label="提交人最末部门负责人"
                          ></el-option>
                          <el-option
                            value="SECOND_DEPT_MANAGER"
                            label="提交人二级部门负责人"
                          ></el-option>
                          <el-option
                            value="HEAD_DEPT_MANAGER"
                            label="提交人一级部门负责人"
                          ></el-option>
                          <el-option
                            value="HEAD_OF_CENTER"
                            label="提交人中心负责人"
                          ></el-option>
                          <el-option
                            value="CONSULTING_REGIONAL_MANAGER"
                            label="提交人咨询区经"
                          ></el-option>
                          <el-option
                            value="CONSULTING_SUPERVISOR"
                            label="提交人咨询主管"
                          ></el-option>
                          <!-- v4.0 -->
                          <el-option
                            value="REGIONAL_BUSINESS_BUSINESS_MANAGER"
                            label="区域业务商务负责人"
                          ></el-option>
                          <el-option
                            value="COMPANY_BUSINESS_MANAGER"
                            label="机构商务负责人"
                          ></el-option>
                          <el-option
                            value="CUSTOMER_CONSULTING"
                            label="客户所属咨询"
                          ></el-option>
                          <el-option
                            value="CUSTOMER_CONSULTING_SUPERVISOR"
                            label="客户所属咨询主管"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        v-if="item.type == 'SPECIFIC'"
                        :prop="`${index}.peoples`"
                        :rules="{
                          required: true,
                          message: '请选择审批人',
                          trigger: 'change',
                          validator: (rule, value, callback) =>
                            peoplesValidator(rule, value, callback),
                        }"
                      >
                        <work-order-user-select-v2
                          v-if="allUserOptions"
                          v-model="item.peoples"
                          :allOptions="allUserOptions"
                          size="mini"
                          :disabledNullBeisen="true"
                          :multiple-limit="1"
                        >
                        </work-order-user-select-v2>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">
                      <el-button
                        size="small"
                        type="text"
                        icon="el-icon-delete"
                        @click="midConsiderHandleDel(index)"
                        style="color: #f56c6c !important; margin-left: 10px"
                      />
                    </el-col>
                  </el-row>
                </div>
              </el-form>
              <el-button
                size="small"
                type="success"
                icon="el-icon-plus"
                @click="midConsiderHandleAdd()"
              >
                添加节点
              </el-button>
              <el-divider />
            </div>
          </work-order-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import api from "plus/api";
import draggable from "vuedraggable";
import { getAllUserOptions } from "@/components/workOrderUserSelectV2/userOptionsService.js";
import { throttle } from "lodash";
export default {
  name: "privilege.questionSetting.add",
  components: { draggable },
  data() {
    return {
      pageType: "add",
      switch1: true,
      switch2: true,
      form: {
        midConsiderPeoples: [],
        considerPeoples: [],
        enablePageSubmit: true,
        followPeoples: [],
        labelGroupId: [],
        parentQaTypeId: "",
        qaProcessType: "NORMAL",
        qaTypeDesc: "",
        qaTypeName: "",
        qaTypePrompt: "",
        status: 1,
        submitterPeoples: [],
        templates: [],
        enableEditAttentionUser: true,
        preFilledWords: "",
        restrictedStatus: [],
        forceResp: false,
        // v4.0
        acceptorMode: "", // 承接模式
        allowSpecifyAcceptor: false, // 是否指定承接人
      },
      dynamicAcceptor: "", // 动态承接人绑定值

      workSubmitRules: {
        parentQaTypeId: [
          {
            required: true,
            message: "请选择工单分类",
            trigger: "change",
          },
        ],
        qaTypeName: [
          {
            required: true,
            message: "请填写工单类型",
            trigger: "blur",
          },
        ],
        considerPeoples: [
          {
            required: true,
            type: "array",
            message: "请选择承接人",
            trigger: "change",
          },
        ],
        acceptorMode: [
          {
            required: true,
            message: "请选择承接人类型",
            trigger: "change",
          },
        ],
      },
      workCutList: [], //工单分类
      initTemplateEnum: [
        "WORK_ORDER_TOPIC",
        "WORK_ORDER_DESCRIBE",
        "IMAGE_UPLOAD",
        "ATTACHMENTS_UPLOAD",
        "PRIORITY",
      ],
      templateOther: [],
      templateEnum: [
        {
          isRequired: true,
          moduleName: "WORK_ORDER_TOPIC",
          sortNum: 0,
          label: "问题标题",
        },
        {
          isRequired: true,
          moduleName: "WORK_ORDER_DESCRIBE",
          sortNum: 0,
          label: "问题描述",
        },
        {
          isRequired: false,
          moduleName: "IMAGE_UPLOAD",
          sortNum: 0,
          label: "图片上传",
        },
        {
          isRequired: false,
          moduleName: "ATTACHMENTS_UPLOAD",
          sortNum: 0,
          label: "附件上传",
        },
        {
          isRequired: false,
          moduleName: "PRIORITY",
          sortNum: 0,
          label: "优先级",
        },
        {
          isRequired: false,
          moduleName: "RELATION_WORK_ORDER",
          sortNum: 0,
          label: "关联工单",
        },
        {
          isRequired: false,
          moduleName: "CUSTOMER_INFO",
          sortNum: 0,
          label: "用户信息",
        },
        {
          isRequired: false,
          moduleName: "ATTENTION_USER",
          sortNum: 0,
          label: "关注人",
        },
        {
          isRequired: false,
          moduleName: "WEBSITE_INFO",
          sortNum: 0,
          label: "网站信息",
        },
        {
          isRequired: false,
          moduleName: "COMPANY_MODEL",
          sortNum: 0,
          label: "相关机构",
        },
        {
          isRequired: false,
          moduleName: "MONEY_MODEL",
          sortNum: 0,
          label: "涉及金额",
        },
        {
          isRequired: false,
          moduleName: "LABEL_MODEL",
          sortNum: 0,
          label: "标签",
        },
        {
          isRequired: false,
          moduleName: "DOCTOR_INFO",
          sortNum: 0,
          label: "医生信息",
        },
        // v4.0
        {
          isRequired: true,
          moduleName: "REGIONAL",
          sortNum: 0,
          label: "地区信息",
          allowChangeRequired: false,
          allowMove: true,
        },
        {
          isRequired: false,
          moduleName: "ACCURATE_PROJECT_INFO",
          sortNum: 0,
          label: "精准项目信息",
        },
        {
          isRequired: true,
          moduleName: "ACCURATE_CUSTOMER_INFO",
          sortNum: 0,
          tips: "（用户ID或手机号必填其一）",
          label: "精准客户信息",
          allowChangeRequired: false,
          allowMove: true,
        },
        {
          isRequired: true,
          moduleName: "ACCURATE_COMPANY_MODEL",
          sortNum: 0,
          tips: "（机构信息从系统中获取匹配）",
          label: "精准机构信息",
          allowChangeRequired: false,
          allowMove: true,
        },
        {
          isRequired: true,
          moduleName: "BUSINESS_TYPE",
          sortNum: 0,
          label: "业务类型",
          allowChangeRequired: false,
          allowMove: true,
        },
        // {
        //     isRequired: false,
        //     moduleName: "SPECIAL_SETTING",
        //     sortNum: 0,
        //     label: "特殊配置",
        // }
      ],
      tagsOptions: [],
      allUserOptions: [],
      submitLoading: false,
    };
  },
  activated() {},
  created() {
    this.getType();
    this.initTemplate();
    this.initTemplateOther();
    this.getAllTag();
    if (this.$route.query.id) {
      this.getDetail();
      this.pageType = "update";
    }
    this.init();
  },
  deactivated() {
    this.resetData();
  },
  watch: {},
  methods: {
    async init() {
      this.allUserOptions = await getAllUserOptions();
    },
    async getDetail() {
      const response = await api.privilege.getQuesttingDetail({
        id: this.$route.query.id,
      });
      if (response.data.success) {
        this.form = response?.data?.data || {};
        this.form.restrictedStatus = response.data.data.restrictedStatus.map(
          (x) => Number(x),
        );
        if (this.form.acceptorMode !== "SPECIFIC") {
          this.dynamicAcceptor = this.form.acceptorMode;
          this.form.acceptorMode = "DYNAMIC";
          // this.dynamicAcceptorSelectChange(this.dynamicAcceptor,true);
        }
        if (this.form.considerPeoples == null) {
          this.form.considerPeoples = [];
        }
        this.formatTemplate();
      }
    },
    async getAllTag() {
      const response = await api.manage.getAllTag();
      this.tagsOptions = response?.data?.data;
    },
    resetData() {
      this.form = {
        midConsiderPeoples: [],
        considerPeoples: [],
        enablePageSubmit: false,
        followPeoples: [],
        labelGroupId: [],
        parentQaTypeId: "",
        qaProcessType: "NORMAL",
        qaTypeDesc: "",
        qaTypeName: "",
        qaTypePrompt: "",
        status: 0,
        submitterPeoples: [],
        templates: [],
        enableEditAttentionUser: true,
      };
    },
    submit() {
      this.submitLoading = true;
      try {
        if (this.form.qaProcessType === "EXAMINE") {
          // 审批节点数量校验
          if (
            !this.form.midConsiderPeoples ||
            this.form.midConsiderPeoples.length < 1
          ) {
            this.$message.error("请进行流程配置");
            return;
          }

          // 流程配置表单验证
          let midConsiderFormValid = false;
          this.$refs["midConsiderForm"].validate((valid) => {
            midConsiderFormValid = valid;
            if (valid) {
              this.form.midConsiderPeoples.forEach((item, index) => {
                item.sort = index + 1; // 更新 sort 字段，值为当前索引
              });
            }
          });
          if (!midConsiderFormValid) {
            return;
          }
        }

        this.$refs["workSubmitForm"].validate(async (valid) => {
          if (valid) {
            // 判断标签是否必填
            let flag = this.form.templates.some(
              (item) => item.moduleName == "LABEL_MODEL",
            );
            if (flag) {
              if (
                !this.form.labelGroupId ||
                this.form.labelGroupId.length <= 0
              ) {
                this.$message.error("请选择标签配置");
                return;
              }
            }
            // v4.0
            if (this.form.acceptorMode === "DYNAMIC") {
              if (this.dynamicAcceptor == null || this.dynamicAcceptor == "") {
                this.$message.error("请选择承接方式");
                return;
              }
              this.form.acceptorMode = this.dynamicAcceptor;
            }
            // 补丁:如果承接人只有一个人时，需要关闭可承接人
            if (this.form.considerPeoples.length == 1) {
              this.form.allowSpecifyAcceptor = false;
            }
            //

            if (this.pageType === "add") {
              const response = await api.privilege.addQuestting(this.form);
              if (response.data.success) {
                this.$message.success("成功");
                this.$router.back();
              } else {
                this.$message.error(response.data.msg);
              }
            } else if (this.pageType === "update") {
              const response = await api.privilege.updateQuestting(this.form);
              if (response.data.success) {
                this.$message.success("成功");
                this.$router.back();
              } else {
                this.$message.error(response.data.msg);
              }
            }
          }
        });
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.form = this.$options.data().form;
      this.$router.back();
    },
    getType() {
      api.dropDownList.getWorkCut().then((res) => {
        this.workCutList = res.data.data;
      });
    },
    initTemplate() {
      this.form.templates = this.templateEnum
        .filter((item) => {
          return this.initTemplateEnum.includes(item.moduleName);
        })
        .map((item, index) => {
          return {
            ...item,
            sortNum: index,
          };
        });
    },
    initTemplateOther() {
      this.templateOther = this.templateEnum.filter((item) => {
        return !this.initTemplateEnum.includes(item.moduleName);
      });
    },
    formatTemplate() {
      this.form.templates = this.form.templates.map((item) => {
        const target = this.templateEnum.filter(
          (tg) => tg.moduleName === item.moduleName,
        );
        return { ...target[0], ...item };
      });
      const isSelected = this.form.templates.map((item) => item.moduleName);
      this.templateOther = this.templateOther.filter(
        (item) => !isSelected.includes(item.moduleName),
      );
    },
    handleDrag() {
      this.form.templates = this.form.templates.map((item, index) => {
        return {
          ...item,
          sortNum: index,
        };
      });
    },
    // v4.0
    onMoveTemplate(evt) {
      const unChooseDrag = document.getElementById("unChooseDrag");
      const chooseDrag = document.getElementById("chooseDrag");
      const dragged = evt.draggedContext && evt.draggedContext.element;
      // 选中到待选
      if (evt.to === unChooseDrag && evt.from === chooseDrag) {
        if (dragged && dragged.allowMove === false) {
          this.showMoveWarning("该选项不允许移动到未添加列表");
          return false;
        }
      }
      // 待选到选中可以是选填
      if (evt.from == unChooseDrag && evt.to === chooseDrag) {
        dragged.allowChangeRequired = true;
        dragged.allowMove = true;
        dragged.moveType = "manual"; // 手动移动
      }
      return true;
    },
    // 节流提示
    showMoveWarning: throttle(function (message) {
      this.$message.warning(message);
    }, 3000),

    qaProcessTypeChange(val) {
      if (val === "EXAMINE") {
        this.form.midConsiderPeoples = [];
        this.form.forceResp = false;
        this.form.reprocessingPersons = [];
      } else {
        this.form.midConsiderPeoples = [];
      }
    },
    // 流程配置
    midConsiderHandleAdd() {
      if (this.form.midConsiderPeoples.length == 10) {
        this.$message.error("节点数量已达上限");
        return;
      }
      this.form.midConsiderPeoples.push({
        sort: this.form.midConsiderPeoples.length + 1,
        name: "",
        type: undefined,
        peoples: [],
      });
    },
    midConsiderHandleDel(index) {
      const item = this.form.midConsiderPeoples[index];
      // v4.0
      if (
        item.type &&
        [
          "REGIONAL_BUSINESS_BUSINESS_MANAGER",
          "COMPANY_BUSINESS_MANAGER",
          "CUSTOMER_CONSULTING",
          "CUSTOMER_CONSULTING_SUPERVISOR",
        ].includes(item.type)
      ) {
        if (this.dynamicAcceptor !== item.type) {
          if (item.type == "REGIONAL_BUSINESS_BUSINESS_MANAGER") {
            this.form.templates = this.form.templates.filter(
              (x) => x.moduleName !== "REGIONAL",
            );
            this.form.templates = this.form.templates.filter(
              (x) => x.moduleName !== "BUSINESS_TYPE",
            );
          }
          if (item.type == "COMPANY_BUSINESS_MANAGER") {
            this.form.templates = this.form.templates.filter(
              (x) => x.moduleName !== "ACCURATE_COMPANY_MODEL",
            );
          }
          if (item.type == "CUSTOMER_CONSULTING") {
            if (
              this.findApproveHasDynamic().length > 1 &&
              this.findApproveHasDynamic().includes("CUSTOMER_CONSULTING") &&
              this.findApproveHasDynamic().includes(
                "CUSTOMER_CONSULTING_SUPERVISOR",
              )
            ) {
              console.log("选中了咨询师和咨询师主管，则需要保留一个"); // test
            } else {
              this.form.templates = this.form.templates.filter(
                (x) => x.moduleName !== "ACCURATE_CUSTOMER_INFO",
              );
            }
          }
          if (item.type == "CUSTOMER_CONSULTING_SUPERVISOR") {
            if (
              this.findApproveHasDynamic().length > 1 &&
              this.findApproveHasDynamic().includes("CUSTOMER_CONSULTING") &&
              this.findApproveHasDynamic().includes(
                "CUSTOMER_CONSULTING_SUPERVISOR",
              )
            ) {
              console.log("选中了咨询师和咨询师主管，则需要保留一个"); // test
            } else {
              this.form.templates = this.form.templates.filter(
                (x) => x.moduleName !== "ACCURATE_CUSTOMER_INFO",
              );
            }
            // this.form.templates = this.form.templates.filter(x=>x.moduleName !== 'ACCURATE_CUSTOMER_INFO');
          }
          this.templateOther = this.templateEnum.filter(
            (x) =>
              !this.form.templates.some((y) => x.moduleName == y.moduleName),
          );
        }
      }

      this.form.midConsiderPeoples.splice(index, 1);
    },
    peoplesValidator(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error("请选择审批人"));
        return;
      }
      callback();
    },
    typeChange(_val, index) {
      this.form.midConsiderPeoples[index].peoples = [];
      this.$nextTick(() => {
        this.$refs.midConsiderForm.clearValidate(`${index}.peoples`);
      });
      // v4.0
      this.form.templates = this.form.templates.filter(
        (x) => x.isFlow == undefined || x.isFlow === false,
      ); // 清除切换审批类型带来的重复问题
      this.dynamicAcceptorSelectChange(_val, false);
    },
    // v4.0
    dynamicAcceptorChange() {
      if (this.form.acceptorMode === "DYNAMIC") {
        this.form.considerPeoples = [];
        this.form.allowSpecifyAcceptor = false;
      } else {
        this.changeTemplate("SPECIFIC");
        this.dynamicAcceptor = "";
      }
    },
    /**
     * 动态承接选中事件
     * @param val 选中值
     * @param isSelect 是否是下拉选中（区别于流程模块中选中承接人）
     */
    dynamicAcceptorSelectChange(val, isSelect) {
      console.log("还原选中事件", val, isSelect); // test
      // 获取用户手动选择的模块
      const manualList = this.form.templates.filter((item) => {
        if (item.moveType && item.moveType == "manual") {
          return true;
        } else {
          return false;
        }
      });
      console.log("流程调试-首选拿到用户手动的模块", manualList);

      if (isSelect) {
        const flowChooseList = this.form.templates.filter(
          (x) => x.isFlow != undefined && x.isFlow === true,
        );
        this.form.templates = [
          ...this.form.templates.filter(
            (x) =>
              ![
                "REGIONAL",
                "ACCURATE_CUSTOMER_INFO",
                "ACCURATE_COMPANY_MODEL",
                "BUSINESS_TYPE",
              ].includes(x.moduleName),
          ),
          ...flowChooseList,
        ];
      }

      // 区域业务商务负责人
      if (val == "REGIONAL_BUSINESS_BUSINESS_MANAGER") {
        // 选中模板
        if (
          !this.form.templates.some((item) => item.moduleName == "REGIONAL")
        ) {
          this.form.templates.push({
            isRequired: true,
            moduleName: "REGIONAL",
            sortNum: 0,
            label: "地区信息",
            allowMove: false,
            isFlow: isSelect ? false : true, // 是否是审批流程选中
          });
        }
        if (
          !this.form.templates.some(
            (item) => item.moduleName == "BUSINESS_TYPE",
          )
        ) {
          this.form.templates.push({
            isRequired: true,
            moduleName: "BUSINESS_TYPE",
            sortNum: 0,
            label: "业务类型",
            allowMove: false,
            isFlow: isSelect ? false : true, // 是否是审批流程选中
          });
          //
          if (isSelect) {
            this.initTemplateEnum.push("REGIONAL");
            this.initTemplateEnum.push("BUSINESS_TYPE");
          }
        }
      }

      // 机构商务负责人
      if (val == "COMPANY_BUSINESS_MANAGER") {
        // 选中模板
        if (
          !this.form.templates.some(
            (item) => item.moduleName == "ACCURATE_COMPANY_MODEL",
          )
        ) {
          this.form.templates.push({
            isRequired: true,
            moduleName: "ACCURATE_COMPANY_MODEL",
            sortNum: 0,
            tips: "（机构信息从系统中获取匹配）",
            label: "精准机构信息",
            allowMove: false,
            isFlow: isSelect ? false : true, // 是否是审批流程选中
          });
        }
        //
        if (isSelect) {
          this.initTemplateEnum.push("ACCURATE_COMPANY_MODEL");
        }
      }

      // 客户所属咨询
      if (val == "CUSTOMER_CONSULTING") {
        // 选中模板
        if (
          !this.form.templates.some(
            (item) => item.moduleName == "ACCURATE_CUSTOMER_INFO",
          )
        ) {
          this.form.templates.push({
            isRequired: true,
            moduleName: "ACCURATE_CUSTOMER_INFO",
            sortNum: 0,
            tips: "（用户ID或手机号必填其一）",
            label: "精准客户信息",
            allowMove: false,
            isFlow: isSelect ? false : true, // 是否是审批流程选中
          });
        }
        //
        if (isSelect) {
          this.initTemplateEnum.push("ACCURATE_CUSTOMER_INFO");
        }
      }

      // 客户所属咨询主管
      if (val == "CUSTOMER_CONSULTING_SUPERVISOR") {
        // 选中模板
        if (
          !this.form.templates.some(
            (item) => item.moduleName == "ACCURATE_CUSTOMER_INFO",
          )
        ) {
          this.form.templates.push({
            isRequired: true,
            moduleName: "ACCURATE_CUSTOMER_INFO",
            sortNum: 0,
            tips: "（用户ID或手机号必填其一）",
            label: "精准客户信息",
            allowMove: false,
            isFlow: isSelect ? false : true, // 是否是审批流程选中
          });
        }
        //
        if (isSelect) {
          this.initTemplateEnum.push("ACCURATE_CUSTOMER_INFO");
        }
      }

      // 获取流程中的模块
      const flowModuleList = this.findApproveHasDynamic();
      let flowList = [];
      for (let item of flowModuleList) {
        if (item == "REGIONAL_BUSINESS_BUSINESS_MANAGER") {
          const regional = this.templateEnum.find(
            (x) => x.moduleName == "REGIONAL",
          );
          const businessType = this.templateEnum.find(
            (x) => x.moduleName == "BUSINESS_TYPE",
          );
          regional.isFlow = true;
          businessType.isFlow = true;
          regional.allowMove = false;
          businessType.allowMove = false;
          regional.isRequired = true;
          businessType.isRequired = true;

          flowList.push(regional);
          flowList.push(businessType);
        }
        if (item == "COMPANY_BUSINESS_MANAGER") {
          const accurateCompanyModel = this.templateEnum.find(
            (x) => x.moduleName == "ACCURATE_COMPANY_MODEL",
          );
          accurateCompanyModel.isFlow = true;
          accurateCompanyModel.allowMove = false;
          accurateCompanyModel.isRequired = true;
          flowList.push(accurateCompanyModel);
        }
        if (item == "CUSTOMER_CONSULTING") {
          const accurateCustomerInfo = this.templateEnum.find(
            (x) => x.moduleName == "ACCURATE_CUSTOMER_INFO",
          );
          accurateCustomerInfo.isFlow = true;
          accurateCustomerInfo.allowMove = false;
          accurateCustomerInfo.isRequired = true;
          flowList.push(accurateCustomerInfo);
        }
        if (item == "CUSTOMER_CONSULTING_SUPERVISOR") {
          const accurateCustomerInfo = this.templateEnum.find(
            (x) => x.moduleName == "ACCURATE_CUSTOMER_INFO",
          );
          accurateCustomerInfo.isFlow = true;
          accurateCustomerInfo.allowMove = false;
          accurateCustomerInfo.isRequired = true;
          flowList.push(accurateCustomerInfo);
        }
      }
      console.log("流程调试-获取流程中的模块2", flowList);
      // 最后加上手动添加的模块和流程模块
      this.form.templates = this.uniqueFunc(
        [...this.form.templates, ...manualList, ...flowList],
        "moduleName",
      );
      this.templateOther = this.templateEnum.filter(
        (item) =>
          !this.form.templates.some((x) => x.moduleName == item.moduleName),
      );
    },

    changeTemplate(type) {
      // 获取用户手动选择的模块
      const manualList = this.form.templates.filter((item) => {
        if (item.moveType && item.moveType == "manual") {
          return true;
        } else {
          return false;
        }
      });
      //
      const flowModuleList = this.findApproveHasDynamic();
      let flowList = [];
      for (let item of flowModuleList) {
        if (
          this.form.templates.some(
            (y) => y.moduleName == this.getMoudleNameByFlowTypeValue(item),
          )
        ) {
          flowList.push(
            this.form.templates.find(
              (y) => y.moduleName == this.getMoudleNameByFlowTypeValue(item),
            ),
          );
        }
      }

      if (type == "SPECIFIC") {
        // 还原拖拽
        this.initTemplateEnum = this.initTemplateEnum.filter((item) => {
          return ![
            "REGIONAL",
            "ACCURATE_CUSTOMER_INFO",
            "ACCURATE_COMPANY_MODEL",
            "BUSINESS_TYPE",
          ].includes(item);
        });
        // 还原选中
        this.form.templates = this.form.templates.filter((item) => {
          return ![
            "REGIONAL",
            "ACCURATE_CUSTOMER_INFO",
            "ACCURATE_COMPANY_MODEL",
            "BUSINESS_TYPE",
          ].includes(item.moduleName);
        });

        this.form.templates = this.uniqueFunc(
          [...this.form.templates, ...manualList, ...flowList],
          "moduleName",
        );
        this.templateOther = this.templateEnum.filter(
          (item) =>
            !this.form.templates.some((x) => x.moduleName == item.moduleName),
        );
      }
    },
    // 查找审批流程中是否有动态承接
    findApproveHasDynamic() {
      const dynamicTypeList = [
        "REGIONAL_BUSINESS_BUSINESS_MANAGER",
        "COMPANY_BUSINESS_MANAGER",
        "CUSTOMER_CONSULTING",
        "CUSTOMER_CONSULTING_SUPERVISOR",
      ];
      const list = this.form.midConsiderPeoples.filter((x) =>
        dynamicTypeList.includes(x.type),
      );
      const dyList = [...new Set(list.map((x) => x.type))];
      return dyList;
    },
    uniqueFunc(arr, uniId) {
      const res = new Map();
      return arr.filter(
        (item) => !res.has(item[uniId]) && res.set(item[uniId], 1),
      );
    },
    // 转换流程中模块名称
    getMoudleNameByFlowTypeValue(typeValue) {
      if (typeValue == "REGIONAL_BUSINESS_BUSINESS_MANAGER") return "REGIONAL";
      if (typeValue == "COMPANY_BUSINESS_MANAGER")
        return "ACCURATE_COMPANY_MODEL";
      if (typeValue == "CUSTOMER_CONSULTING") return "ACCURATE_CUSTOMER_INFO";
      if (typeValue == "CUSTOMER_CONSULTING_SUPERVISOR")
        return "ACCURATE_CUSTOMER_INFO";
      return "";
    },
  },
};
</script>
<style lang="less" scoped>
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .demo-ruleForm input.el-input__inner {
  width: 388px;
}

/deep/ .demo-ruleForm textarea.el-textarea__inner {
  width: 388px;
  height: 150px;
}

.demo-ruleForm {
  width: 100%;
}

.writeWork {
  // display: flex;
  // // justify-content: center;
  // align-items: center;
  // flex-direction: column;
  width: 100%;
  background-color: white;
}

.top {
  width: 100%;
  height: 70px;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #333333;
  line-height: 70px;
}

.top::before {
  margin-left: 14px;
  margin-right: 8px;
  content: "";
  border-left: 4px solid #3572e2;
  height: 16px;
}

.main {
  padding: 20px;
}

.tishi {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
  margin-bottom: 10px;
  text-align: center;
}

.avatar-uploader {
  margin-top: 25px;
}

.add-details-btn {
  width: 150px;
  height: 50px;
  background: #3572e2;
  border-radius: 2px;
  color: #fff;
  font-size: 16px;
  border-color: #3572e2;
}

.add-edit-btn {
  width: 124px;
  height: 50px;
  border: 1px solid #e1e1e1;
  border-radius: 2px;
  background-color: #fff;
}

.add-back-btn {
  width: 124px;
  height: 50px;
  border: 1px solid #e1e1e1;
  border-radius: 2px;
  background-color: #fff;
}

.grop-box {
  display: flex;
  border: solid 1px #eee;

  .group-left {
    width: 200px;
    height: 200px;
    overflow: auto;
    border-right: solid 1px #eee;
    padding-left: 30px;
    box-sizing: border-box;
  }

  .group-right {
    width: 200px;
    height: 200px;
    overflow: auto;

    /deep/ input.el-input__inner {
      width: 100%;
    }

    .tag-list {
      width: 200px;
      display: flex;
      flex-wrap: wrap;

      .tag-item {
        margin: 10px;
      }
    }
  }

  .group-title {
    font-size: 14px;
    line-height: 2em;
    overflow: auto;
    text-align: center;
  }
}

.list-item {
  background: #ffffff;
  height: 32px;
  display: flex;
  align-items: center;
  border: 1px solid;
  margin-bottom: 10px;
  padding: 10px;

  i {
    margin-right: 10px;
    font-size: 18px;
  }

  .required-switch {
    margin-left: auto;
  }

  .disabled {
    pointer-events: none;
    cursor: not-allowed;
  }
}
</style>
